module.exports = __webpack_public_path__ + "img/logoCard.a060d211.png";